import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../shared/Image';
import virtualServiceIcon from '../../../../../../images/icons/icon-video.svg';
import { openModal } from '../VirtualServiceEducationModal';
import analytics from '../../../../../modules/analytics';
import '../../Notification.scss';
import './VirtualServiceNotification.scss';
import { BodyText } from '../../../../ui';
import { ModalContextPropType } from '../../../../ui/ModalContext';

/**
 * Add Virtual Service notification
 */
const VirtualServiceNotification = ({ notification, modalContext }) => (
  <button
    type="button"
    onClick={() => {
      analytics.track('virtual_service_education_modal_opened_from_notification');
      openModal(modalContext, notification);
    }}
    className="button-notification"
  >
    <section className="notification">
      <div className="icon">
        <Image
          source={{
            uri: virtualServiceIcon,
            width: 32,
            height: 23,
            resizeMode: 'center',
          }}
        />
      </div>
      <section className="notification-body short-block">
        <div className="notification-text">
          <BodyText weight="bold">Can&apos;t be in the salon?</BodyText>
          <p className="notification-indent">
            Join hundreds of pros already offering virtual services.
          </p>
          <strong className="notification-learn-more">Add a Virtual Service</strong>
        </div>
      </section>
    </section>
  </button>
);

VirtualServiceNotification.propTypes = {
  modalContext: ModalContextPropType,
  notification: PropTypes.object.isRequired,
};

VirtualServiceNotification.defaultProps = {
  modalContext: null,
};

export default VirtualServiceNotification;
